import script from "./country-box.vue?vue&type=script&setup=true&lang=ts"
export * from "./country-box.vue?vue&type=script&setup=true&lang=ts"

import "./country-box.vue?vue&type=style&index=0&id=49a397c4&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49a397c4"]])

export default __exports__